import React, { Fragment, useEffect, useState } from 'react';
import './province.scss';
import Card from '../../components/card';
import AtresPieChart from '../../components/charts/atresPieChart';
import Tag from '../../components/tag';
import Tags from '../../components/tags';
import { PlacesProvider, getPlace } from '../../dataProvider/places';
import PactometroCheckSimple from '../../components/pactometroCheck/pactometroCheckSimple';
import CustomMap from '../../components/homeMap/customMap';
import ElTabs from '../../components/elTabs';
import {
  TYPES,
  SUBTYPES,
  CODE_CANARY,
  EXCLUDED_REGIONS
} from '../../envs/core';
import { ResultProvider } from '../../dataProvider/results';
import { getResultOrigin } from '../../dataProvider/origin';
import Autocomplete from '../../components/autocomplete/index';
import { getData } from '../../dataProvider/places/single';
import MasterBar from '../../components/masterBar';
import BreadCrumb from '../../components/breadCrumb';
import NewTable from '../../components/table/newTable';

import HorizontalGraph from '../../components/horizontalGraph';

const Chart =
  window.location.hostname
    .replace('localhost', 'lasexta')
    .indexOf('lasexta') === -1
    ? AtresPieChart
    : HorizontalGraph;

const PactosTxt =
  window.location.hostname
    .replace('localhost', 'antena3')
    .indexOf('lasexta') === -1
    ? 'Pactos'
    : 'Pactómetro';

const getRoute = (town, electionNumber, year, electionsType) => {
  const host = window.location.hostname.replace('localhost', 'antena3');
  if (host.indexOf('lasexta') !== -1) {
    let currentYear = '';
    if (year !== '2019') {
      currentYear = '/' + year;
    }
    return `https://www.lasexta.com/noticias/nacional/elecciones-${electionsType}/resultados${currentYear}/${electionNumber}${
      town ? town.path : '/espana'
    }`;
  }
  if (host.indexOf('antena3') !== -1) {
    return `https://www.antena3.com/noticias/elecciones/resultados/elecciones-${electionsType}/${year}/${electionNumber}${
      town ? town.path : '/espana'
    }`;
  }
  if (host.indexOf('ondacero') !== -1) {
    let currentYear = '';
    let electionsTypeAux = '';
    if (year !== '2019') {
      currentYear = '/' + year;
    }
    if (electionsType === 'autonomicas') {
      electionsTypeAux = '-' + electionsType;
    }
    if (electionsType === 'municipales' || electionsType === 'autonomicas') {
      electionsType = 'municipales-autonomicas';
    }
    return `https://www.ondacero.es/noticias/elecciones-${electionsType}/resultados${electionsTypeAux}${currentYear}/${electionNumber}${
      town ? town.path : '/espana'
    }`;
  }
};

const addRoute = (data, electionNumber, community) => {
  return data.map(town => {
    let route = getRoute(town, electionNumber, '2019', 'autonomicas');
    if (!community) {
      const splits = route.split('/');
      route = route.replace(`/${splits[splits.length - 1]}`, '');
    }
    return { ...town, href: route };
  });
};

const getWinnerInfo = (winners, filter) => {
  const result = Object.keys(winners)
    .filter(key => key.startsWith('R'))
    .reduce((total, data) => {
      let provinceWinner = winners[data].find(el => el.placeId === data);

      const provinceTotal = winners[data]
        .filter(el => el.placeId !== data)
        .map(el => {
          if (filter) {
            return { ...el };
          } else {
            return { ...provinceWinner, placeId: el.placeId };
          }
        });

      total = [...provinceTotal, ...total];

      return total;
    }, []);
  return result;
};

const SimpleAutonomicResult = ({ match, history }) => {
  const {
    year,
    electionNumber,
    reload,
    community,
    province,
    masterbar
  } = match.params;

  const isCanary = province && community === CODE_CANARY;
  const [autocomple, setAutocomple] = useState('');
  const [autocompleLocalities, setAutocompleLocalities] = useState('');
  const [selectedCommunity, setSelectedCommunity] = useState({});
  const [selectedProvince, setSelectedProvince] = useState({});
  const [mapData, setMapData] = useState([]);
  const [resultOrigin, setResultOrigin] = useState();
  const [lastYear, setLastYear] = useState();
  const [allRegions, setAllRegions] = useState([]);

  const tabsTitle = isCanary
    ? ['C.INSULAR', 'C.AUTONÓMICA', PactosTxt]
    : ['Datos', `${lastYear}`, PactosTxt];
  const elSubtype = isCanary ? SUBTYPES.INSULAR : SUBTYPES.SINGLE;

  useEffect(() => {
    getResultOrigin(year, TYPES.REGIONAL, electionNumber, community || 'R13')
      .then(historicResult => {
        setResultOrigin(historicResult);
        setLastYear(historicResult.historic.year);
      })
      .catch(err => {});
  }, [year, electionNumber]);

  useEffect(() => {
    getData(community || 'R13').then(place => {
      setSelectedCommunity(place);
    });
    if (province) {
      getData(province).then(place => {
        setSelectedProvince(place);
      });
    }
  }, [community, province]);

  useEffect(() => {
    getPlace(`typeplace=PROVINCE&size=60`).then(places => {
      const placesWithRoute = addRoute(
        places.content,
        electionNumber,
        Boolean(community)
      );
      setMapData(placesWithRoute);
    });
    getPlace('typeplace=REGION&parentid=C108&size=1000').then(regions => {
      setAllRegions(regions.content);
    });
  }, []);

  const goToDetails = child => {
    if (Boolean(reload)) {
      window.location.href = getRoute(
        child,
        electionNumber,
        year,
        'autonomicas'
      );
    } else {
      history.push(
        `/${masterbar}/${reload}/2019/${electionNumber}/${child.grandpaId}/${child.parentId}/${child.ineId}/detalleAutonomica.html`
      );
    }
  };

  const changeProvince = (lol, place) => {
    const provinceId = place ? place : lol;

    if (community) {
      if (Boolean(parseInt(reload))) {
        const ruta = getRoute(provinceId, electionNumber, year, 'autonomicas');
        window.location.href = ruta;
      } else {
        history.push(
          `/${masterbar}/${reload}/2019/${electionNumber}/${community}/${provinceId.ineId}/resultadosautonomicos.html`
        );
      }
    } else {
      if (Boolean(parseInt(reload))) {
        const ruta = getRoute(provinceId, electionNumber, year, 'autonomicas');
        window.location.href = ruta;
      } else {
        history.push(
          `/${masterbar}/${reload}/2019/${electionNumber}/${
            provinceId.typePlace === 'PROVINCE'
              ? provinceId.parentId
              : provinceId.ineId
          }/resultadosautonomicos.html`
        );
      }
    }
  };

  const goParent = place => {
    if (Boolean(parseInt(reload))) {
      const ruta = getRoute(place, electionNumber, year, 'autonomicas');
      window.location.href = ruta;
    } else {
      history.push(
        `/${masterbar}/${reload}/2019/${electionNumber}${
          place ? '/' + place.ineId : ''
        }/resultadosautonomicos.html`
      );
    }
  };

  return (
    <Fragment>
      <div className="mainWrapper pageDetails pageDetails_Autonomicas">
        {Boolean(parseInt(masterbar)) && (
          <MasterBar current="autonomicas" history={history} reload={reload} />
        )}
        {resultOrigin && resultOrigin.primary && selectedCommunity.ineId ? (
          <ResultProvider
            electionPlace={selectedCommunity.ineId}
            active={resultOrigin.primary.active}
            year={year}
            type={TYPES.REGIONAL}
            subtype={elSubtype}
            electionNumber={electionNumber}
            placeId={selectedProvince.ineId || selectedCommunity.ineId}
          >
            {dataResult => (
              <div className="colContainer">
                <div className="floatingBlock left">
                  <div className="inner">
                    <BreadCrumb
                      type="AUTONÓMICAS"
                      community={province ? selectedCommunity : null}
                      onClick={goParent}
                    />
                    <div className="mapSelectorContainer">
                      <div className="mapContainer">
                        <div className="selectedTownContainer">
                          <span class="selectedTownTitle">
                            {community &&
                              (selectedProvince.name || selectedCommunity.name)}
                          </span>
                          <PlacesProvider
                            type={
                              !community && !province ? 'REGION' : 'PROVINCE'
                            }
                            name={autocomple}
                            sortby={autocomple ? 'score' : 'name'}
                            parentId={community ? community : null}
                            excludedGrandParentIds={EXCLUDED_REGIONS}
                          >
                            {data => {
                              return (
                                <Autocomplete
                                  results={data}
                                  onChange={value => setAutocomple(value)}
                                  onSelect={select => {
                                    changeProvince(select);
                                  }}
                                  placeholder={
                                    community
                                      ? 'Seleccione provincia'
                                      : 'Seleccione Comunidad Autónoma'
                                  }
                                  showArrow
                                />
                              );
                            }}
                          </PlacesProvider>
                        </div>
                        <div className="selectsContainer" />
                        {mapData && mapData.length ? (
                          <ResultProvider
                            electionPlace={'C108'}
                            active={resultOrigin.primary.active}
                            year={year}
                            type={TYPES.REGIONAL}
                            subtype={SUBTYPES.SINGLE}
                            electionNumber={electionNumber}
                            placeId={''}
                          >
                            {generalData => (
                              <Fragment>
                                <CustomMap
                                  partiesWinners={getWinnerInfo(
                                    generalData || [],
                                    community
                                  )}
                                  isFiltered={community}
                                  allRegions={allRegions}
                                  excludedGrandParentIds={EXCLUDED_REGIONS}
                                  maps={
                                    community
                                      ? mapData.filter(
                                          pro => pro.parentId === community
                                        )
                                      : mapData
                                  }
                                  currentCommunity={
                                    selectedCommunity ? community : null
                                  }
                                  selectedPlace={selectedProvince || {}}
                                  native={Boolean(parseInt(reload))}
                                  onChange={changeProvince}
                                />
                              </Fragment>
                            )}
                          </ResultProvider>
                        ) : (
                          <div className="loader">...cargando</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="floatingBlock right">
                  <div className="inner">
                    <h2
                      class={
                        !community
                          ? 'defaultCommunity default'
                          : 'defaultCommunity'
                      }
                    >
                      {!community
                        ? 'Comunidad de Madrid'
                        : selectedProvince.name || selectedCommunity.name}
                    </h2>

                    <Card
                      title="ESCRUTADO:"
                      titleValue={
                        dataResult.updateDate
                          ? `${Number(
                              dataResult.currentCountPercent
                            ).toLocaleString('es')} %`
                          : 'Cargando...'
                      }
                      subtitle={
                        dataResult.updateDate
                          ? `Actualizado a las: ${dataResult.updateDate.slice(
                              0,
                              -3
                            )}`
                          : 'Cargando...'
                      }
                    >
                      <Fragment>
                        <div className="participationTitles">
                          <div className="participationTitle">
                            <span className="key">PARTICIPACIÓN: </span>
                            <span className="value">
                              {dataResult.updateDate
                                ? `${Number(
                                    dataResult.participationPercent
                                  ).toLocaleString('es')} %`
                                : 'Cargando...'}
                            </span>
                          </div>
                          <div className="participationTitle">
                            <span className="key">ESCAÑOS: </span>
                            <span className="value">
                              {dataResult.totalVotes
                                ? Number(dataResult.totalSeats).toLocaleString(
                                    'es'
                                  )
                                : 'Cargando...'}
                            </span>
                          </div>
                        </div>
                        <Chart
                          showLabel={!province}
                          data={dataResult.partiesResult || []}
                          dataKey="seats"
                          showFaces={false}
                          seatTotal={dataResult.totalSeats || 0}
                          total={dataResult.totalSeats || 0}
                        />
                      </Fragment>
                    </Card>
                  </div>
                </div>

                <div className="floatingBlock right">
                  <div className="inner">
                    <ElTabs titles={tabsTitle}>
                      <NewTable
                        data={dataResult.partiesResult || []}
                        cols={[
                          {
                            label: '',
                            key: 'partyAcronym',
                            classHead: 'partido',
                            classBody: 'dato-nombre-partido',
                            showColor: true
                          },
                          {
                            label: 'Escaños',
                            key: 'seats',
                            classHead: 'porcentaje',
                            classBody: 'dato-escanos',
                            map: data => Number(data).toLocaleString('es')
                          },
                          {
                            label: '%',
                            key: 'votesPercent',
                            classHead: 'porcentaje',
                            classBody: 'dato-escanos',
                            map: data => Number(data).toLocaleString('es')
                          },
                          {
                            label: 'Votos',
                            key: 'votes',
                            classHead: 'porcentaje',
                            classBody: 'dato-escanos',
                            map: data => Number(data).toLocaleString('es')
                          }
                        ].filter(col => {
                          if (community === 'R05' && !isCanary) {
                            return col.key.indexOf('votes') === -1;
                          } else {
                            return true;
                          }
                        })}
                      />
                      <div className="oldChartContainer">
                        <ResultProvider
                          electionPlace={selectedCommunity.ineId}
                          active={
                            isCanary
                              ? resultOrigin.primary.active
                              : resultOrigin.historic.active
                          }
                          year={
                            isCanary
                              ? resultOrigin.primary.year
                              : resultOrigin.historic.year
                          }
                          type={TYPES.REGIONAL}
                          subtype={isCanary ? TYPES.REGIONAL : elSubtype}
                          electionNumber={electionNumber}
                          placeId={
                            selectedProvince.ineId || selectedCommunity.ineId
                          }
                        >
                          {oldData => {
                            return oldData && oldData.partiesResult ? (
                              <NewTable
                                data={oldData.partiesResult || []}
                                cols={[
                                  {
                                    label: '',
                                    key: 'partyAcronym',
                                    classHead: 'partido',
                                    classBody: 'dato-nombre-partido',
                                    showColor: true
                                  },
                                  {
                                    label: 'Escaños',
                                    key: 'seats',
                                    classHead: 'porcentaje',
                                    classBody: 'dato-escanos',
                                    map: data =>
                                      Number(data).toLocaleString('es')
                                  },
                                  {
                                    label: '%',
                                    key: 'votesPercent',
                                    classHead: 'porcentaje',
                                    classBody: 'dato-escanos',
                                    map: data =>
                                      Number(data).toLocaleString('es')
                                  },
                                  {
                                    label: 'Votos',
                                    key: 'votes',
                                    classHead: 'porcentaje',
                                    classBody: 'dato-escanos',
                                    map: data =>
                                      Number(data).toLocaleString('es')
                                  }
                                ]}
                              />
                            ) : (
                              <div>Sin datos</div>
                            );
                          }}
                        </ResultProvider>
                      </div>
                      <div className="pactometroWrapper">
                        <ResultProvider
                          active={
                            resultOrigin &&
                            resultOrigin.primary &&
                            resultOrigin.primary.active
                          }
                          year={
                            resultOrigin &&
                            resultOrigin.primary &&
                            resultOrigin.primary.year
                          }
                          type={TYPES.REGIONAL}
                          placeId={selectedCommunity.ineId}
                          subtype={elSubtype}
                          electionPlace={selectedCommunity.ineId}
                          electionNumber={electionNumber}
                        >
                          {generalData => (
                            <div className="pactometroScroll">
                              <PactometroCheckSimple
                                totalSeat={generalData.totalSeats}
                                seatData={generalData.partiesResult || []}
                              />
                            </div>
                          )}
                        </ResultProvider>
                      </div>
                    </ElTabs>
                  </div>
                </div>

                <div className="floatingBlock left">
                  <div className="inner">
                    <Card
                      title="Principales localidades de "
                      titleValue={
                        community
                          ? selectedProvince.name || selectedCommunity.name
                          : 'España'
                      }
                    >
                      {selectedProvince || selectedCommunity ? (
                        <div className="selectsContainer CityTagsselectsContainer">
                          <PlacesProvider
                            type="TOWN"
                            name={autocompleLocalities}
                            sortby={autocompleLocalities ? 'score' : 'name'}
                            grandParentId={null}
                            excludedGrandParentIds={EXCLUDED_REGIONS}
                          >
                            {data => {
                              return (
                                <Autocomplete
                                  results={data}
                                  onChange={value =>
                                    setAutocompleLocalities(value)
                                  }
                                  onSelect={select => goToDetails(select)}
                                  placeholder="Escribe una localidad"
                                  showArrow
                                />
                              );
                            }}
                          </PlacesProvider>
                        </div>
                      ) : null}
                      <Tags>
                        <PlacesProvider
                          type="TOWN"
                          size={10}
                          sortby="main"
                          parentId={province ? selectedProvince.ineId : null}
                          grandParentId={
                            !province && community
                              ? selectedCommunity.ineId
                              : null
                          }
                          excludedGrandParentIds={EXCLUDED_REGIONS}
                        >
                          {data =>
                            data &&
                            data.map(town => (
                              <Tag
                                key={`${town.ineId}-${town.name}`}
                                onClick={() => goToDetails(town)}
                                native={Boolean(parseInt(reload))}
                                route={getRoute(
                                  town,
                                  electionNumber,
                                  year,
                                  'autonomicas'
                                )}
                              >
                                {town.name}
                              </Tag>
                            ))
                          }
                        </PlacesProvider>
                      </Tags>
                    </Card>
                  </div>
                </div>
              </div>
            )}
          </ResultProvider>
        ) : (
          <div className="loader">loading</div>
        )}
      </div>
    </Fragment>
  );
};

export default SimpleAutonomicResult;
